import React, { useState, useEffect } from "react";
import smartParkService from "../../../axios";
import _ from "lodash";
import "../../../assets/scss/App.scss";
import { Box, Typography } from "@material-ui/core";
import { useLocation } from "react-router-dom";

export default function SensorInfoWidget({ dashboardData }) {
  const location = useLocation();
  const park = location.pathname.replace(/^\/+/, "");
  const park_id =
    park === "CederForkDistrictPark"
      ? "c7a1d85f-8168-4e64-8e38-116a0624bfea"
      : park === "ChurchStreetPark"
        ? "ba0a6f3f-e265-43d1-aaf8-ff21d43d3944"
        : park === "MAFC"
          ? "91474e36-76c5-4d59-a8da-2998ab14a4bf"
          : park === "ccnp"
            ? "c7a1d85f-8168-4e64-8e38-116a0624bfed"
            : park === "shiloh"
              ? "c7a1d85f-8168-4e64-8e38-116a0624bfec"
              : park === "MorrisvilleCommunityPark"
                ? "c7a1d85f-8168-4e64-8e38-116a0624bfeb"
                : park === "CedarForkCommunityCenter"
                  ? "c8a2d96f-8168-4e64-8e38-116a0624bfee"
                  : null;
  const [sensorInfo, setSensorInfo] = useState([]);

  const fetchDashboardData = async () => {
    const response = await smartParkService.get("api/dashboard/data");
    const data = await response.data;
    processData({ data: data.data });
  };

  const processData = ({ data }) => {
    if (!park_id) return;
    const sensorInfo = data?.find((val) => val.park_id === park_id)?.field_data;
    const info = sensorInfo.filter((info) => {
      return info.group_name !== "Field STATUS";
    });
    setSensorInfo(info);
  };

  React.useEffect(() => {
    if (dashboardData?.length > 0 && park_id) {
      processData({ data: dashboardData });
    }
    if (!dashboardData) {
      fetchDashboardData();
    }
  }, []);

  return (
    <div>
      {sensorInfo.length > 0 && (
        <div class="box">
          <div class="box-header text-center">
            <h6>Sensor Info</h6>
          </div>
          <div
            key={"Sensors"}
            style={{
              padding: 10,
              maxHeight: "300px",
              overflowY: "scroll",
            }}
          >
            <h6 className="title1 samesize">{sensorInfo[0]?.group_name}</h6>
            <ul className="status-list">
              {sensorInfo.map((sensor, idx) => {
                // if (idx > 0) return null;
                const finalStatusArray =
                  typeof sensor.finalStatus === "string"
                    ? sensor.finalStatus
                        .split(";;")
                        .map((group) =>
                          group.split("::").map((item) => item.trim()),
                        )
                    : [[sensor.finalStatus]];
                const direction =
                  finalStatusArray.length > 1 || finalStatusArray[0].length > 1
                    ? "column"
                    : "row";

                return (
                  <li key={sensor.field_id}>
                    <Box
                      style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        flexDirection: direction,
                      }}
                    >
                      <Typography variant="body1">
                        {sensor.field_name}
                      </Typography>
                      {finalStatusArray.map((group, groupIndex) => (
                        <div
                          key={groupIndex}
                          style={{
                            display: "inline-flex",
                            flexWrap: "wrap",
                            gap: 8,
                            width: direction === "row" ? "fit-content" : "100%",
                            maxWidth: "100%",
                            marginBottom:
                              groupIndex !== finalStatusArray.length - 1
                                ? 8
                                : 0,
                          }}
                        >
                          {group.map((item, itemIndex) => (
                            <label
                              key={itemIndex}
                              className="open"
                              style={{
                                textTransform: "uppercase",
                                flex: "1 1 calc(33.333% - 8px)",

                                padding: "4px 8px",
                                textAlign: "center",
                                boxSizing: "border-box",
                                whiteSpace: "wrap",
                              }}
                            >
                              {item}
                            </label>
                          ))}
                        </div>
                      ))}
                    </Box>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}
